import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import { MDXProvider } from '@mdx-js/react';
import { MDXRenderer } from 'gatsby-plugin-mdx';

import { Seo } from 'components';
import { buildServiceSchema } from 'utils/serviceSchema';

import * as Elements from 'elements';
import * as Components from 'components';

const SITE_URL = 'https://www.nimax.ru';

/**
 * Лендинг департамента
 */

export default ({ data,
  data: {
    page: {
      frontmatter: { title, seo_title, full_title, og, description, schemaData }
    }
  },
  location
}) => {
  const pageUrl = location ? `${SITE_URL}${location.pathname}` : undefined;
  const schemaObj = buildServiceSchema({ title, description, pageUrl, schemaData });

  return (
    <>
      <Seo
        title={seo_title || full_title || title} og={og} description={description} schema={schemaObj}
      />
      <MDXProvider components={{ ...Components, ...Elements }}>
        <MDXRenderer>{data.page.body}</MDXRenderer>
      </MDXProvider>
    </>
  );
};

export const pageQuery = graphql`
  query($id: String!) {
    page: mdx(id: {eq: $id}) {
      frontmatter {
        title
        full_title
        seo_title
        redirect
        og
        description
        schemaData {
          organization
          serviceList {
            name
          }
          breadcrumbs {
            url
            name
          }
        }
      }
      body
    }
  }
`;
